<h1>Dostupné stránky</h1>

<ul>
    <li *ngFor="let model of razorModels$ | async">
        <razor-model-feature [model]="model"></razor-model-feature>
    </li>
</ul>